import axios from "axios";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import pulpLogo from "../assets/img/pulpmag.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser, faHouse, faFile, faBook, faUsers, faVideo, faUserShield, faSignOutAlt, faGear, faPen } from '@fortawesome/free-solid-svg-icons';
import AuthModal from '../Modal/AuthenticateModal';
import { toast } from "sonner";
import Editor from '../../Components/EditorJS';

export default function Sidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = (path: string) => location.pathname === path;
    const [author, setAuthor] = useState<string | null>(null);
    const [role, setRole] = useState<string | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false); 
    const [isLoading, setIsLoading] = useState(false);

    const openAuthModal = () => {
		setIsModalOpen(true); 
	};
	
	const closeAuthModal = () => {
		setIsModalOpen(false); 
	};

    const [testModalOpen, setTestModalOpen] = useState(false);
        
    const openTestModal = () => {
        setTestModalOpen(true); 
    };
    
    const closeTestModal = () => {
        setTestModalOpen(false); 
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            window.location.replace("/login");
        } else {
            setAuthor(localStorage.getItem("author"));
            setRole(localStorage.getItem("role"));
        }
    }, []);

    useEffect(() => {
        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted) { 
                window.location.reload();
            }
        };

        window.addEventListener("pageshow", handlePageShow);

        return () => {
            window.removeEventListener("pageshow", handlePageShow);
        };
    }, []);

    const userLogout: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await axios.post(
                "https://cdn.pulp.ph/api/logout",
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                }
            );
        } catch (error) {
            console.error("Logout API failed:", error);
        } finally {
            localStorage.clear();
            delete axios.defaults.headers.common["Authorization"];
            toast.success("Logged out successfully", { duration: 1000 });
            window.location.replace("/login");
        }
    };

    const showData: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        console.log('Hello World!');
    };

    return (
        <>
            <AuthModal
                isOpen={isModalOpen}
                onClose={closeAuthModal}
                title="Action Verification"
                content={<div className='text-base mb-3'>Are you sure you want to log out?</div>}
                footer={
                    <>
                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                            onClick={closeAuthModal}>
                            Close
                        </button>

                        <button 
							disabled={isLoading}
							className="m-0 px-4 py-2 GraphikSemibold text-sm text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                            onClick={userLogout}>
							{isLoading ? "Confirming..." : "Confirm"}
                        </button>
                    </>
                }
            />

            <AuthModal
                isOpen={testModalOpen}
                onClose={closeTestModal}
                title="Action Verification"
                content={
                        <div className="text-base mb-3">
                            <Editor onChange={(data) => {
                                console.log('External handler received data:', data);
                            }}/>
                        </div>
                    }
                footer={
                    <>
                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                            onClick={closeTestModal}>
                            Close
                        </button>
                        <button 
                            className="m-0 px-4 py-2 GraphikSemibold text-sm text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
                            onClick={showData}>
                            Confirm
                        </button>
                    </>
                }
            />

            <aside className="col-start-1 row-start-1 bg-white">
                <div className="px-0">
					<div className="pulp-logo h-auto w-auto flex justify-center items-center py-4 px-5">
                        <img src={pulpLogo} className="h-[77px] w-[90px]" alt="pulp logo" />
					</div>
					
					<div className="userProfile flex items-center gap-3 py-2 px-5">
						<div className="userPicture flex items-center justify-center">
							<FontAwesomeIcon icon={faCircleUser} style={{ fontSize: '32px' }} className="text-[#1f2328]" />
						</div>

						<div className="userDescription flex flex-col items-start">
							<h2 className="GraphikSemibold text-[14px] text-[#1f2328] pt-2">{author}</h2> 
							<p className="GraphikRegular text-[14px] text-[#1f2328] font-normal">{role}</p>
						</div>
					</div>
				</div>

                <nav className="mt-2">
                    <ul>
                      <li className={`hover:text-red-500 hover:bg-gray-300 ${isActive("/dashboard") ? "text-red-500" : ""}`}>
                            <Link to="/dashboard" className="flex Univers-BoldCondensed items-center gap-3 py-3 px-5">
                                <FontAwesomeIcon icon={faHouse} />
                                DASHBOARD
                            </Link>
                        </li>
                        <li className={`hover:text-red-500 hover:bg-gray-300 ${isActive("/view/post/shortStory") ? "text-red-500" : ""}`}>
                            <Link to="/view/post/shortStory" className="flex Univers-BoldCondensed items-center gap-3 py-3 px-5">
                                <FontAwesomeIcon icon={faFile} />
                                SHORT STORY
                            </Link>
                        </li>
                        <li className={`hover:text-red-500 hover:bg-gray-300 ${isActive("/view/post/longStory") ? "text-red-500" : ""}`}>
                            <Link to="/view/post/longStory" className="flex Univers-BoldCondensed items-center gap-3 py-3 px-5">
                                <FontAwesomeIcon icon={faBook} />
                                LONG STORY
                            </Link>
                        </li>
                        <li className={`hover:text-red-500 hover:bg-gray-300 ${isActive("/view/post/community") ? "text-red-500" : ""}`}>
                            <Link to="/view/post/community" className="flex Univers-BoldCondensed items-center gap-3 py-3 px-5">
                                <FontAwesomeIcon icon={faUsers} />
                                COMMUNITY
                            </Link>
                        </li>
                        <li className={`hover:text-red-500 hover:bg-gray-300 ${isActive("/view/post/video") ? "text-red-500" : ""}`}>
                            <Link to="/view/post/video" className="flex Univers-BoldCondensed items-center gap-3 py-3 px-5">
                                <FontAwesomeIcon icon={faVideo} />
                                VIDEO
                            </Link>
                        </li>
                        <li className={`hover:text-red-500 hover:bg-gray-300 ${isActive("/admin") ? "text-red-500" : ""}`}>
                            <p className="flex items-center gap-3 Univers-BoldCondensed text-base py-3 px-5" data-tooltip-id="feature">
                                <span className="w-5 flex justify-center">
                                    <FontAwesomeIcon icon={faUserShield} />
                                </span>
                                ADMIN
                            </p>
                        </li>
                        <li className={`hover:text-red-500 hover:bg-gray-300 ${isActive("/settings") ? "text-red-500" : ""}`}>
                            <Link to="/settings" className="flex Univers-BoldCondensed items-center gap-3 py-3 px-5">
                                <FontAwesomeIcon icon={faGear} />
                                SETTINGS
                            </Link>
                        </li>
                        <li className="hover:text-red-500 hover:bg-gray-300">
                            <button onClick={openAuthModal} className="flex Univers-BoldCondensed items-center gap-3 py-3 px-5">
                                <FontAwesomeIcon icon={faSignOutAlt} />
                                LOGOUT
                            </button>
                        </li>
                        {/* <li className={`hover:text-red-500 hover:bg-gray-300 hover:bg-opacity-40`}>
							<button onClick={openTestModal} className="flex items-center gap-3 Univers-BoldCondensed text-base py-3 px-5"> 
                                <span className="w-5 flex justify-center">
                                    <FontAwesomeIcon icon={faPen} />
                                </span>
                                EDITOR
							</button>
						</li> */}
                    </ul>
                </nav>
            </aside>
        </>
    )
}
